import { MenuModel } from '@bo-client/core/navigation/menu.model';

export enum UserMenuActionEnum {
  changeProfile = 'changeProfile',
  changePassword = 'changePassword',
  logout = 'logout',
  changePersonalization = 'changePersonalization',
  appNews = 'appNews'
}

export const UserMenu: MenuModel[] = [
  {
    label: 'Passwort ändern',
    icon: 'key',
    action: UserMenuActionEnum.changePassword,
    roles: ['ALL_USERS']
  },
  {
    label: 'Profil bearbeiten',
    icon: 'person_edit',
    action: UserMenuActionEnum.changeProfile,
    roles: ['ALL_USERS']
  },
  {
    label: 'Personalisierung anpassen',
    icon: 'brush',
    action: UserMenuActionEnum.changePersonalization,
    roles: ['ALL_USERS']
  },
  {
    // Neuigkeiten für Sachbearbeiter; Superadmins sehen sie hier zur Kontrolle.
    // Siehe docs/technical/components/app-news.md
    label: 'Neuigkeiten',
    icon: 'campaign',
    action: UserMenuActionEnum.appNews,
    roles: ['ROLE_EDITOR_BASE', 'ROLE_SUPERADMIN']
  },
  {
    // Logout steht immer als letzter Eintrag; neue Einträge kommen darüber.
    label: 'Logout',
    icon: 'logout',
    action: UserMenuActionEnum.logout,
    roles: ['ALL_USERS']
  }
];
